/* eslint no-console: 0 */
import React from 'react';
import styled from 'styled-components';

import { Device } from '../../hooks/useGetCurrentUserDevices.js';
import {
  DEFAULT_DEVICE_ONLINE_STATE_COLOR,
  deviceOnlineStateColor
} from '../../services/device-utils-v2';

interface CircleProps {
  color?: string;
}
const Circle = styled.div<CircleProps>`
  height: 8px;
  width: 8px;
  background-color: ${props => props.color || DEFAULT_DEVICE_ONLINE_STATE_COLOR};
  border-radius: 50%;
  display: inline-block;
  margin-left: 2px;
  margin-right: 2px;
`;

interface DeviceStatusIndicatorProps {
  device: Device,
}

export const DeviceStatusIndicator: React.FC<DeviceStatusIndicatorProps> = ({ device }) => {

  const color = deviceOnlineStateColor(device);

  return (
    <Circle color={color} />
  );
};


